(() => {
  const root = window.Shopify?.routes?.root || '/';
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-vipa-screenwash-cart-add]');
    if (!button || button.disabled) return;
    event.preventDefault();
    button.disabled = true;
    const oldText = button.textContent;
    button.textContent = button.dataset.loadingText || oldText;
    const error = button.closest('.vipa-screenwash')?.querySelector('[data-vipa-screenwash-error]');
    if (error) {
      error.hidden = true;
      error.textContent = '';
    }
    try {
      const response = await fetch(button.dataset.cartAddUrl + '.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: [{ id: Number(button.dataset.variantId), quantity: 1 }] })
      });
      const payload = await response.json();
      if (!response.ok || payload.status) throw new Error(payload.description || payload.message || button.dataset.errorText);
      window.location.assign(root + 'cart');
    } catch (failure) {
      if (error) {
        error.hidden = false;
        error.textContent = failure.message || button.dataset.errorText;
      }
      button.disabled = false;
      button.textContent = oldText;
    }
  });
})();
